module.exports = __webpack_public_path__ + "img/brompton_logo.114faa57.svg";